import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  DPAMRequestData, DPAMRequestI, DPAMRequestMarketingDetailsI,
  DPAMRequestRedemptionDetailsI, GroupAttributeI, ViewLevel
} from '../../services/product-setup.service';

import { DigitalFilesComponent } from '../digital-files/digital-files.component';
import { ProductSetupChangesService } from '../../../core/settings/product-setup-changes.service';
import { EN } from 'app/core/translator/EN';
import { MarketingDetailsComponent } from './marketing-details/marketing-details.component';
import { GroupRedemptionDetailsComponent } from './group-redemption-details/group-redemption-details.component';
import { GroupMarketingDetailsComponent } from './group-marketing-details/group-marketing-details.component';
import { RedemptionDetailsComponent } from './redemption-details/redemption-details.component';
import { Subject } from 'rxjs';
import { untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-product-setup-product-tab',
  templateUrl: './product-setup-product-tab.component.html',
  styleUrls: ['./product-setup-product-tab.component.scss']
})
export class ProductSetupProductTabComponent implements OnInit, OnChanges {
  EN = EN;
  productFieldsArray = ['MARKETING_DETAILS', 'REDEMPTION_DETAILS', 'DIGITAL_FILES_ORIGINAL', 'DIGITAL_FILES_FINAL'];
  switchActionComponent: string | null;
  settingActive = this.productFieldsArray[0];
  ViewLevel = ViewLevel;

  displayedColumns = ['productUPC', 'inCommProductName'];
  dataSource: MatTableDataSource<any>;
  @Input() productRequest: UntypedFormGroup;
  @Input() data: DPAMRequestData | null = null;
  @Input() isShowWarning: boolean;
  @Input() viewLevel: ViewLevel;
  @Input() listOfUPC: { dataPath: string, request: DPAMRequestI }[];
  @Input() selectedUPC: { dataPath: string, request: DPAMRequestI };
  @Input() groupAttributes: GroupAttributeI[];
  @Input() isActionsDisabled = false;

  @Output() save: EventEmitter<{ editingRequest: DPAMRequestMarketingDetailsI | DPAMRequestRedemptionDetailsI, editingSection: string }> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() setActiveSetting: EventEmitter<string> = new EventEmitter();
  @Output() selectUPC: EventEmitter<{ dataPath: string, request: DPAMRequestI }> =
    new EventEmitter<{ dataPath: string, request: DPAMRequestI }>();

  @ViewChild('digitalFilesOriginal', { static: true }) digitalFilesOriginal: DigitalFilesComponent;
  @ViewChild('digitalFilesFinal', { static: true }) digitalFilesFinal: DigitalFilesComponent;
  marketingDetails: Subject<void> = new Subject<void>();
  redemptionDetails: Subject<void> = new Subject<void>();
  groupMarketingDetails: Subject<void> = new Subject<void>();
  groupRedemptionDetails: Subject<void> = new Subject<void>();
  index = 0;
  previousUPC: { dataPath: string, request: DPAMRequestI };
  constructor(
    private uiChangesService: ProductSetupChangesService
  ) {
  }

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.listOfUPC);
    this.previousUPC = Object.assign({}, this.selectedUPC);
  }

  ngOnChanges(event) {
    if (event.hasOwnProperty('settingActive')) {
      this.setSettingActive(this.settingActive);
    }
  }

  setSettingActive(value: any) {
    this.settingActive = value;
    this.switchActionComponent = null;
    this.setActiveSetting.emit(value);
  }

  onSaveProduct(event: { editingRequest: DPAMRequestMarketingDetailsI | DPAMRequestRedemptionDetailsI, editingSection: string }) {
    const productRequest = Object.assign({}, this.data.dpamRequest.productRequest, event.editingRequest);
    this.save.emit({
      editingRequest: productRequest,
      editingSection: event.editingSection
    });
  }

  handleTabChange(e: MouseEvent, tabIndex) {
    e.stopPropagation();
    if (this.index === tabIndex) {
      return;
    }
    this.uiChangesService.continueWithoutChanges()
      .pipe(untilDestroyed(this), take(1))
      .subscribe(flag => {
        if (flag) {
          this.index = tabIndex;
        } else {
          return;
        }
      });
  }

  onUPCChange(event) {
    console.log(event)
    this.uiChangesService.continueWithoutChanges()
      .pipe(untilDestroyed(this), take(1))
      .subscribe(flag => {
        if (flag) {
          setTimeout(() => { this.previousUPC = Object.assign({}, this.selectedUPC) });
          this.selectUPC.emit(event);
        }
        else {
          setTimeout(() => { this.selectedUPC = Object.assign({}, this.previousUPC); });
        }
      })
  }
}
